import React from 'react';
import styles from './styles.module.scss';


export default ({ onClick, children }) => {
  return <div className={styles.container}>
    <button onClick={onClick} className={styles.button}>{children}</button>
  </div>;
};
